module.exports = __webpack_public_path__ + "static/media/square.470f4568.svg";